import request from "@ali/request-olympics";
import { transformUrl } from '../../adapter/request';
import { getParams } from "../../utils";

const report = (data) => {
  try {
    const { _kamala_task_id_: taskDetailId } = getParams();
    request.post(transformUrl("/api/save/form/state/data"), {
      taskDetailId,
      formStateData: JSON.stringify(data),
    });
  } catch (e) {
    console.warn("kamala report fail, ", e);
  }
};

export default function KamlaReport({ context, fieldApi }) {
  const kamlaReport = () => {
    const data = fieldApi.getFieldsState();
    report(data);
  };
  Object.assign(context, { kamlaReport });
}
